import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";

const Home = lazy(() => import("@/pages/home/page"));
const RankingPage = lazy(() => import("@/pages/ranking/page"));
const SearchPage = lazy(() => import("@/pages/search/page"));
const AdvancedSearchPage = lazy(() => import("@/pages/advanced-search/page"));
const WorkDetailPage = lazy(() => import("@/pages/works/detail/page"));
const GenresPage = lazy(() => import("@/pages/genres/page"));
const NewWorksPage = lazy(() => import("@/pages/new/page"));
const ArticlesPage = lazy(() => import("@/pages/articles/page"));
const ArticleDetailPage = lazy(() => import("@/pages/articles/detail/page"));
const DiscoverPage = lazy(() => import("@/pages/discover/page"));
const ComparePage = lazy(() => import("@/pages/compare/page"));
const FavoritesPage = lazy(() => import("@/pages/favorites/page"));
const WatchLaterPage = lazy(() => import("@/pages/watch-later/page"));
const SettingsPage = lazy(() => import("@/pages/settings/page"));
const AboutPage = lazy(() => import("@/pages/about/page"));
const ContactPage = lazy(() => import("@/pages/contact/page"));
const PrivacyPage = lazy(() => import("@/pages/privacy/page"));
const TermsPage = lazy(() => import("@/pages/terms/page"));
const DisclosurePage = lazy(() => import("@/pages/disclosure/page"));

function PageFallback() {
  return (
    <div role="status" className="flex min-h-[60vh] items-center justify-center gap-2 text-sm text-foreground-500">
      <i className="ri-loader-4-line animate-spin text-lg" aria-hidden="true" />
      読み込み中…
    </div>
  );
}

const fallbackElement = <PageFallback />;

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={fallbackElement}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/ranking",
    element: (
      <Suspense fallback={fallbackElement}>
        <RankingPage />
      </Suspense>
    ),
  },
  {
    path: "/search",
    element: (
      <Suspense fallback={fallbackElement}>
        <SearchPage />
      </Suspense>
    ),
  },
  {
    path: "/advanced-search",
    element: (
      <Suspense fallback={fallbackElement}>
        <AdvancedSearchPage />
      </Suspense>
    ),
  },
  {
    path: "/works/:id",
    element: (
      <Suspense fallback={fallbackElement}>
        <WorkDetailPage />
      </Suspense>
    ),
  },
  {
    path: "/genres",
    element: (
      <Suspense fallback={fallbackElement}>
        <GenresPage />
      </Suspense>
    ),
  },
  {
    path: "/new",
    element: (
      <Suspense fallback={fallbackElement}>
        <NewWorksPage />
      </Suspense>
    ),
  },
  {
    path: "/articles",
    element: (
      <Suspense fallback={fallbackElement}>
        <ArticlesPage />
      </Suspense>
    ),
  },
  {
    path: "/articles/:slug",
    element: (
      <Suspense fallback={fallbackElement}>
        <ArticleDetailPage />
      </Suspense>
    ),
  },
  {
    path: "/discover",
    element: (
      <Suspense fallback={fallbackElement}>
        <DiscoverPage />
      </Suspense>
    ),
  },
  {
    path: "/compare",
    element: (
      <Suspense fallback={fallbackElement}>
        <ComparePage />
      </Suspense>
    ),
  },
  {
    path: "/favorites",
    element: (
      <Suspense fallback={fallbackElement}>
        <FavoritesPage />
      </Suspense>
    ),
  },
  {
    path: "/watch-later",
    element: (
      <Suspense fallback={fallbackElement}>
        <WatchLaterPage />
      </Suspense>
    ),
  },
  {
    path: "/settings",
    element: (
      <Suspense fallback={fallbackElement}>
        <SettingsPage />
      </Suspense>
    ),
  },
  {
    path: "/about",
    element: (
      <Suspense fallback={fallbackElement}>
        <AboutPage />
      </Suspense>
    ),
  },
  {
    path: "/contact",
    element: (
      <Suspense fallback={fallbackElement}>
        <ContactPage />
      </Suspense>
    ),
  },
  {
    path: "/privacy",
    element: (
      <Suspense fallback={fallbackElement}>
        <PrivacyPage />
      </Suspense>
    ),
  },
  {
    path: "/terms",
    element: (
      <Suspense fallback={fallbackElement}>
        <TermsPage />
      </Suspense>
    ),
  },
  {
    path: "/disclosure",
    element: (
      <Suspense fallback={fallbackElement}>
        <DisclosurePage />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;